var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnStickyNote2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-120 -401)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H4.15833C3.24167 2.5 2.5 3.25 2.5 4.16667L2.50833 15.8333C2.50833 16.75 3.25 17.5 4.16667 17.5H12.5L17.5 12.5V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM5.83333 6.66667H14.1667V8.33333H5.83333V6.66667ZM10 11.6667H5.83333V10H10V11.6667ZM11.6667 16.25V11.6667H16.25L11.6667 16.25Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -185.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStickyNote2);
export default __webpack_public_path__ + "static/media/icn_sticky_note_2.3740c9abcfc84e6b9036f7d08bdf212a.svg";
export { ForwardRef as ReactComponent };